import React from 'react';
import PropTypes from 'prop-types';
export var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};

var InFocusGuard = function InFocusGuard(_ref) {
  var children = _ref.children;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && React.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};

InFocusGuard.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
InFocusGuard.defaultProps = {
  children: null
};
export default InFocusGuard;


//////////////////
// WEBPACK FOOTER
// ./~/react-focus-lock/dist/es2015/FocusGuard.js
// module id = 460
// module chunks = 0